import { render, staticRenderFns } from "./UserDetailUserInfo.vue?vue&type=template&id=bb1acce0&"
import script from "./UserDetailUserInfo.vue?vue&type=script&lang=ts&"
export * from "./UserDetailUserInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailUserInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSpacer,VTooltip})
